import React, { useMemo } from 'react';

import { useGetIptvStatsTableQuery } from '../../redux/apis/analyticsManagement/aMIptvAnalyticsApiSlice';
import ReusableTable from '../other/ReuseableTable';
import ComponentLoader from '../other/ComponentLoader';
import { Card, CardBody } from '../other/card/card';

const columns = [
  {
    title: 'App name',
    dataIndex: 'app_name',
    key: 'app_name',
    sorter: true,
    search: true,
  },
  {
    title: 'Domain',
    dataIndex: 'domain',
    key: 'domain',
    sorter: true,
    search: true,
    render: text => (text ? text : '—'),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    sorter: true,
    search: true,
    render: text => (
      <span className={text === 'Active' ? 'text-success' : ''}>{text || '—'}</span>
    ),
  },
  {
    title: 'IP address',
    dataIndex: 'ip_address',
    key: 'ip_address',
    sorter: true,
    search: true,
    render: text => text || '—',
  },
];

const IPTVStatsTable = () => {
  const { data, isLoading, isError, error } = useGetIptvStatsTableQuery();

  const tableData = useMemo(
    () =>
      (Array.isArray(data) ? data : []).map((row, index) => ({
        ...row,
        id: `iptv-stats-row-${index}-${row?.app_name ?? ''}-${row?.domain ?? ''}-${row?.ip_address ?? ''}`,
      })),
    [data]
  );

  return (
    <div className='row g-2 mt-1'>
      <div className='col-12'>
        <Card className='mb-0'>
          <CardBody className='relative p-0'>
            {isLoading ? <ComponentLoader /> : null}
            {isError ? (
              <div className='absolute inset-0 d-flex items-center justify-center p-3 text-danger small bg-white bg-opacity-75'>
                Failed to load.
                {error?.data?.message ? ` ${error.data.message}` : ''}
              </div>
            ) : null}
            <div className='p-4 d-flex flex-wrap justify-content-between gap-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex fw-bold small'>IPTV general stats</div>
              </div>
            </div>
            <div className='px-4 pb-4'>
              <ReusableTable
                columns={columns}
                data={tableData}
                loading={isLoading}
                pagination={{ pageSize: 15, showSizeChanger: true }}
              />
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default IPTVStatsTable;
